var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavbarChattingOn = function SvgNavbarChattingOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    fillRule: "evenodd",
    d: "M1.5 12C1.5 6.21 6.21 1.5 12 1.5S22.5 6.21 22.5 12c0 2.357-.797 4.651-2.25 6.496V22.5H12C6.21 22.5 1.5 17.79 1.5 12M15 12a1.125 1.125 0 1 0 2.25 0A1.125 1.125 0 0 0 15 12m-3 1.125a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25M6.75 12a1.124 1.124 0 1 0 2.249.001A1.124 1.124 0 0 0 6.75 12",
    clipRule: "evenodd"
  })));
};
export default SvgNavbarChattingOn;